import React, { useState } from "react";
import useLeads from "../useLeads";
import { countActiveFilters } from "./filterTokens";
import useLeadFilters from "./useLeadFilters";
import QuickFilterBar from "./QuickFilterBar";
import ActiveFiltersSummary from "./ActiveFiltersSummary";
import AdvancedFiltersPanel from "./AdvancedFiltersPanel";
import "./leadFilters.css";

const LeadListFilters = () => {
  const {
    actions: leadActions,
    isSearching,
    leadCount,
    isExportingAll,
    exportProgress,
  } = useLeads();
  const { leadsFilters } = useLeadFilters();
  const [showAdvanced, setShowAdvanced] = useState(false);

  const activeFilterCount = countActiveFilters(leadsFilters.filters);

  const onSubmitSearch = (e) => {
    e.preventDefault();
    leadActions.getLeads();
  };

  const exportLabel = isExportingAll
    ? `Export en cours… ${exportProgress.current}/${exportProgress.total}`
    : "Exporter tout (JSON)";

  return (
    <form onSubmit={onSubmitSearch} className="lf mb-3">
      <QuickFilterBar
        showAdvanced={showAdvanced}
        onToggleAdvanced={() => setShowAdvanced((v) => !v)}
        activeFilterCount={activeFilterCount}
      />

      <ActiveFiltersSummary />

      {showAdvanced && (
        <AdvancedFiltersPanel
          onClose={() => setShowAdvanced(false)}
          onExport={leadActions.handleExportAllJSON}
          isExporting={isExportingAll || isSearching || leadCount === 0}
        />
      )}

      {!showAdvanced && (
        <div className="lf-presets" style={{ marginTop: 8 }}>
          <button
            type="button"
            className="lf-link"
            style={{
              border: 0,
              background: "transparent",
              font: "inherit",
              fontSize: 12.5,
              fontWeight: 600,
              color: "var(--lf-ink-3)",
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
            }}
            onClick={leadActions.handleExportAllJSON}
            disabled={isExportingAll || isSearching || leadCount === 0}
            title="Exporter tous les leads (toutes pages) en JSON"
          >
            <i className="fa fa-download" />
            {exportLabel}
          </button>
        </div>
      )}
    </form>
  );
};

export default LeadListFilters;
